import { Button as MuiButton, CustomButtonProps as ButtonProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export const Button = ({ children, m, mt, mb, ml, mr, mx, my, sx, ...otherProps }: ButtonProps) => {
  const marginSx = { m, mt, mb, ml, mr, mx, my };
  const mergedSx: SxProps<Theme> = [marginSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])];

  return (
    <MuiButton sx={mergedSx} {...otherProps}>
      {children}
    </MuiButton>
  );
};
